module.exports = __webpack_public_path__ + "img/7.750147f7.jpg";